import { http, providerApi } from '@/core/api/';

const baseApi = 'api/appointment';

export default {
  getAppointmentSearchData(properties) {
    return http.get('api/appointment', {
      params: {
        ...properties,
      },
    });
  },
  getAppointmentRegistryData(properties) {
    return http.get('api/appointment/registry', {
      params: {
        ...properties,
      },
    });
  },
  getCanceledAppointmentHistory(properties) {
    return http.get('api/appointment/canceledhistory', {
      params: {
        ...properties,
      },
    });
  },
  getAppointmentStatus(properties) {
    return http.get('api/code/appointmentstatus', {
      params: {
        ...properties,
      },
    });
  },
  getAppointmentServices(properties) {
    return http.get('api/code/appointmentservices', {
      params: {
        ...properties,
      },
    });
  },
  getAppointmentSearchInitialFilterValues() {
    return http.get('api/appointment/initfilters');
  },
  confirmAppointmentStatus(params) {
    return http.post('api/appointment/confirmappointment', params);
  },
  denyAppointmentStatus(params) {
    return http.post('api/appointment/deniedappointment', params);
  },
  cancelAppointmentStatus(params) {
    return http.post('api/appointment/cancelappointment', params);
  },
  getReasonsAppointmentStatus(params) {
    params.isReqNewAppoinment =
      params.isReqNewAppoinment === false ? false : true;
    return http.get('api/appointment/statusreasons', { params: params });
  },
  changeCenterAppointment(clientAppointmentId, newCenterId) {
    return http.put(
      `${baseApi}/coordinatedcenter/${clientAppointmentId}/${newCenterId}`
    );
  },
  getAppointmentHistory(clientAppointmentId) {
    return http.get('api/appointment/getappointmenthistory', {
      params: { clientAppointmentId },
    });
  },

  //complete appointment services
  getAppointmentInfo(clientAppointmentId) {
    return http.get(`${baseApi}/getvwclientappointment`, {
      params: {
        clientAppointmentId,
      },
    });
  },
  getAppointmentType() {
    return http.get(`${baseApi}/getappointmenttypes`);
  },
  getSpecialistPractitioners(disciplineTypeId, specialistLocationId) {
    return http.get('api/appointment/getspecialistpractitioners', {
      params: {
        disciplineTypeId,
        specialistLocationId,
      },
    });
  },
  getAppointmentMunicipalities(
    academicYearId,
    companyId,
    disciplineId,
    serviceId,
    locationAddressMunicipalityId
  ) {
    return http.get('api/appointment/getappointmentmunicipality', {
      params: {
        academicYearId,
        companyId,
        disciplineId,
        serviceId,
        locationAddressMunicipalityId,
      },
    });
  },
  getAppointmentLocations(
    academicYearId,
    companyId,
    disciplineId,
    serviceId,
    locationAddressMunicipalityId
  ) {
    return http.get('api/appointment/getappointmentlocationfiscalyear', {
      params: {
        academicYearId,
        companyId,
        disciplineId,
        serviceId,
        locationAddressMunicipalityId,
      },
    });
  },
  getSpecialistByLocation(
    academicYearId,
    companyId,
    disciplineId,
    serviceId,
    locationFiscalYearId
  ) {
    return http.get('api/appointment/getspecialistbylocation', {
      params: {
        academicYearId,
        companyId,
        disciplineId,
        serviceId,
        locationFiscalYearId,
      },
    });
  },
  completeAppointment(params) {
    return http.post('api/appointment/completeappointment', params, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  saveStudentEvaluationDocumentRelationship(params) {
    return http.post(
      'api/appointment/savestudentevaluationdocumentrelationship',
      params
    );
  },
  getAppointmentTherpies(clientAppointmentId) {
    return http.get(`${baseApi}/getappointmenttherapies`, {
      params: {
        clientAppointmentId,
      },
    });
  },
  async getServices(serviceTypeIds, categories) {
    let qs = '';
    if (serviceTypeIds != undefined && serviceTypeIds != null) {
      for (let i = 0; i < serviceTypeIds.length; i++) {
        qs += `serviceTypeIds=${serviceTypeIds[i]}&`;
      }
    }

    if (categories != undefined && categories != null) {
      for (let i = 0; i < categories.length; i++) {
        qs += `categories=${categories[i]}&`;
      }
    }

    if (qs.length > 0) qs = qs.slice(0, -1);

    // In MIPE DB the "discipline types" are in fact the "services"
    return await http.get(`api/code/disciplinetypes?${qs}`);
  },

  //coordinate appointment services
  searchAvailableDates(params) {
    return http.get('/api/appointment/searchdates', {
      params: params,
    });
  },
  getValidAppointmentDisciplines(serviceTypeId) {
    return http.get(
      `${baseApi}/getvalidappointmentdisciplinesforddl/${serviceTypeId}`
    );
  },
  getDisciplines(serviceTypeId) {
    return http.get(`${baseApi}/getdisciplinesforddl/${serviceTypeId}`);
  },
  hasActiveCoordinatedDiscipline(params) {
    return http.get('/api/appointment/hasactivecoordinateddiscipline', {
      params: params,
    });
  },
  hasActiveAppointmentByDiscipline(params) {
    return http.get('/api/appointment/hasactiveappointmentbydiscipline', {
      params: params,
    });
  },
  getMunicipalitiesByDiscipline(params) {
    return http.get('/api/appointment/getmunicipalitiesbydicipline', {
      params: params,
    });
  },
  getBreach(params) {
    return http.get('/api/appointment/getbreach', {
      params: params,
    });
  },
  getRegistrationDate(studentSieId) {
    return http.get(
      `/api/appointment/getregistrationdate?studentSieId=${studentSieId}`
    );
  },
  getStudentDetail(studentSieId) {
    return http.get('/api/student/getstudentdetails', {
      params: { studentSie: studentSieId },
    });
  },
  getAppointmentInfoByClientAppointmentId(clientAppointmentId) {
    return http.get(
      'api/appointment/info?clientAppointmentId=' + clientAppointmentId
    );
  },
  getRelationships() {
    return http.get('api/student/eduespcodes');
  },
  getPhoneProviders() {
    return http.get('api/student/TelephoneProviders');
  },
  getContactInformation(studentSieId) {
    return http.get(`api/student/${studentSieId}/ContactInformation`);
  },
  getPublicPortalContactInformation(appointmentId) {
    return http.get(
      `api/student/publicportal/${appointmentId}/ContactInformation`
    );
  },
  getCenterbyUserId(userId) {
    return http.get(
      `api/eduespuserlocation/servicecenterbyuserid?userId=${userId}`
    );
  },
  getCenters() {
    return http.get('api/code/servicecenter');
  },
  saveAppointmentCoordinate(data, from) {
    return http.post('/api/appointment/coordinate?from=' + from, data);
  },
  getReasonsApointmentStatus(appointmentStatusCd, isReqNewAppoinment = true) {
    return http.get('api/appointment/statusreasons', {
      params: {
        appointmentStatusCd,
        isReqNewAppoinment,
      },
    });
  },
  isValidAvailableSpace(studentSie, scheduleId) {
    return http.get(
      `/api/appointment/isValidAvailableSpace/${studentSie}/${scheduleId}`
    );
  },
  getStatusReasonDetails(appointmentStatusReasonCd) {
    return http.get(
      `/api/appointment/statusreasondetails/${appointmentStatusReasonCd}`
    );
  },
  getCompanies(disciplineTypeId) {
    return http.get(`${baseApi}/appointmentcompanies/${disciplineTypeId}`);
  },
  getMunicipalitiesByFiscalYearAndCompany(fiscalYearId, companyId) {
    return http.get(
      `${baseApi}/municipalitiesByFiscalYearAndCompany/${fiscalYearId}/${companyId}`
    );
  },
  getLocationServicesForSpecialists(fiscalYearId, companyId, disciplineTypeId) {
    return http.get(
      `${baseApi}/locationServicesForSpecialists/${fiscalYearId}/${companyId}/${disciplineTypeId}`
    );
  },
  /**
   *
   * @param { studentSieId, disciplineId, municipalityId  } model
   * @returns
   */
  getDatesWithAvailableSchedules(model) {
    return http.get(
      `${baseApi}/dateswithavailableschedules?studentSieId=${model.studentSieId}&disciplineId=${model.disciplineId}&municipalityId=${model.municipalityId}`
    );
  },
  /**
   * the param @spaceDate is the date where the endpoint will search the available spaces for that DATE.
   * @param { studentSieId, disciplineId, municipalityId, spaceDate, registrationDate } model
   * @returns
   */
  getAvailableScheduleOnDate(model) {
    return http.get(
      `${baseApi}/scheduleondate?studentSieId=${model.studentSieId}&disciplineId=${model.disciplineId}&municipalityId=${model.municipalityId}&spaceDate=${model.spaceDate}&registrationDate=${model.registrationDate}`
    );
  },
  getAppointmentInformation(studentReferralId) {
    return http.get(`${baseApi}/appointmentinformation/${studentReferralId}`);
  },
  isDisciplineExcludedForPilotPlan(disciplineId) {
    return http.get(
      `/api/student/isdisciplineexcludedforpilotplan/${disciplineId}`
    );
  },
  getEvaluationDocument(clientAppointmentId) {
    return http.get(`/appointment/documents/${clientAppointmentId}`);
  },
  saveSpaceCoordination(params) {
    return http.post(`/api/appointment/spacecoordination`, params);
  },
  getContactInformation(studentSieId) {
    return http.get(`/api/student/${studentSieId}/ContactInformation`);
  },
  getMunicipalities(companyId, specialistId) {
    return providerApi.get('/api/providers/appointmentSpace/municipalities', {
      params: { companyId: companyId, specialistId: specialistId },
    });
  },
  createNewInitialReferral(payload) {
    return http.post('/api/appointment/createnewinitialreferral', payload);
  },
  validateNextAppointmentDate(params) {
    return http.get('/api/appointment/validatenextappointmentdate', {
      params: params,
    });
  },
  getAppointmentAdditionalInfo(clientAppointmentId) {
    return http.get(
      `api/appointment/appointmentadditionalinfo/${clientAppointmentId}`
    );
  },
  getAppointmentTherapies(clientAppointmentId) {
    return http.get(
      `api/appointment/appointmenttherapies/${clientAppointmentId}`
    );
  },
};
